export default class UserModel {
  username = "";
  email = "";
  phoneNumber = "";
  firstName = "";
  lastName = "";
  position = "SimpleUser";
  password = "";
  constructor(position) {
    this.position = position;
  }
}
